var angular = require('angular');

angular.module('pitch.app')

    .factory('Site', function(config, $resource) {
        return $resource(config.apiUri + '/sites/:id');
    })

    .factory('SiteLoader', function(Site, $q) {
        return function(params) {
            var delay = $q.defer();

            Site.get(params, function(resp) {
                delay.resolve(resp);
            }, function() {
                delay.reject('Unable to fetch Site');
            });

            return delay.promise;
        };
    })

    .factory('LocalSite', function(config, $http, $q) {
        return {
            get: function(success, fail) {
                var delay = $q.defer();

                $http({
                    url: config.apiUri + '/geoip/country',
                    method: 'GET'
                }).then(function(r) {
                    if (r.data.success) {
                        delay.resolve(r.data.country.site);
                    } else {
                        delay.reject('Unable to fetch Site');
                    }
                });

                return delay.promise;
            }
        };
    })

    /**
     * SiteContext
     *
     * @author Mark Cremer <mark@firstcoders.co.uk>
     */
    .factory('SiteContext', function(satvStorage, LocalSite, $q, $rootScope) {
        var delays = [], isRequesting = false;

        return {
            set: function(site) {
                satvStorage.set('SITE_CONTEXT', angular.toJson(site));
                $rootScope.$emit('SITE_CONTEXT_SET', site);
            },
            get: function() {
                var delay, that;

                delay = $q.defer();
                that = this;

                if (!satvStorage.get('SITE_CONTEXT')) {
                    if (!isRequesting) {

                        //set signpost
                        isRequesting = true;

                        LocalSite.get()
                            .then(function(resp) {
                                //store the result locally for future use
                                that.set(resp);

                                //resolve all delays
                                angular.forEach(delays, function(delay, i) {
                                    delay.resolve(resp);
                                });

                                //empty queue
                                delays = [];

                                //unset signpost
                                isRequesting = false;
                            }, function() {

                                //resolve all delays
                                angular.forEach(delays, function(delay, i) {
                                    delay.reject('Unable to fetch default site');
                                });

                                $rootScope.$broadcast('SITE_CONTEXT_FAIL');

                                //empty queue
                                delays = [];

                                //unset signpost
                                isRequesting = false;
                            })
                        ;
                    }
                } else {
                    delay.resolve(
                        angular.fromJson(satvStorage.get('SITE_CONTEXT'))
                    );
                }

                delays.push(delay);

                return delay.promise;
            }
        };
    });



// WEBPACK FOOTER //
// ./src/AppBundle/Resources/js/angular/services/Site.js